export default __webpack_public_path__ + "ed89bcb3912c866c1da33d3c32cf8afe.coffee";